/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrtitle2Inputs */

const en_checkinqrtitle2 = /** @type {(inputs: Checkinqrtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in code`)
};

const de_checkinqrtitle2 = /** @type {(inputs: Checkinqrtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in-Code`)
};

/**
* | output |
* | --- |
* | "Check-in code" |
*
* @param {Checkinqrtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrtitle2 = /** @type {((inputs?: Checkinqrtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrtitle2(inputs)
	return de_checkinqrtitle2(inputs)
});
export { checkinqrtitle2 as "checkinQrTitle" }